export const LiveToggleIcon = ({ active, className }: { active: boolean; className?: string }): React.ReactElement => {
  return !active ? (
    <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none" className={className}>
      <g filter="url(#filter0_i_136_17324)">
        <circle cx="2" cy="2" r="2" fill="#F4F4F4" />
      </g>
      <defs>
        <filter
          id="filter0_i_136_17324"
          x="0"
          y="0"
          width="5"
          height="5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="1.05" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_136_17324" />
        </filter>
      </defs>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <g filter="url(#filter0_di_395_18626)">
        <circle cx="9" cy="9" r="2" fill="#00EAEA" />
      </g>
      <defs>
        <filter
          id="filter0_di_395_18626"
          x="0.7"
          y="0.7"
          width="16.6"
          height="16.6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_395_18626" />
          <feOffset />
          <feGaussianBlur stdDeviation="2.15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.434761 0 0 0 0 1 0 0 0 0 1 0 0 0 0.44 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_395_18626" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_395_18626" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.75" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0722948 0 0 0 0 0.397357 0 0 0 0 0.441684 0 0 0 0.46 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_395_18626" />
        </filter>
      </defs>
    </svg>
  )
}
